// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck .footnote-section {
	padding: 10px;
	margin: 1em 0;
	background: rgba( 0, 0, 0, 0.02 );
	border: solid 1px hsl(0, 0%, 77%);
	border-radius: 2px;
	counter-reset: footnote-counter;
}

.ck .footnote-item {
	list-style: none;
	counter-increment: footnote-counter;
	margin-left: 0.5em;
	display: flex;
}

.ck .footnote-item > * {
	vertical-align: text-top;
}

.ck .footnote-back-link {
	position: relative;
	margin-right: 0.1em;
	top: -0.2em;
}

.ck .footnotes .footnote-back-link > sup {
	margin-right: 0;
}

.ck .footnote-item::before {
	content: counter(footnote-counter) ". ";
	display: inline-block;
	position: relative;
	right: 0.2em;
	min-width: fit-content;
	text-align: right;
}

.ck .footnote-content {
	display: inline-block;
	padding: 0 0.3em;
	width: 95%;
	border-radius: 2px;
	flex-grow: 1;
}

.ck .ck-widget.footnote-section .ck-widget__type-around__button_after {
	display:none; /* hides the 'insert after' button from the ckeditor widget */
}
`, "",{"version":3,"sources":["webpack://./src/ckeditor5-footnote/theme/footnote.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,aAAa;CACb,iCAAiC;CACjC,iCAAiC;CACjC,kBAAkB;CAClB,+BAA+B;AAChC;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,uCAAuC;CACvC,qBAAqB;CACrB,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,UAAU;CACV,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,YAAY,EAAE,6DAA6D;AAC5E","sourcesContent":[".ck .footnote-section {\n\tpadding: 10px;\n\tmargin: 1em 0;\n\tbackground: rgba( 0, 0, 0, 0.02 );\n\tborder: solid 1px hsl(0, 0%, 77%);\n\tborder-radius: 2px;\n\tcounter-reset: footnote-counter;\n}\n\n.ck .footnote-item {\n\tlist-style: none;\n\tcounter-increment: footnote-counter;\n\tmargin-left: 0.5em;\n\tdisplay: flex;\n}\n\n.ck .footnote-item > * {\n\tvertical-align: text-top;\n}\n\n.ck .footnote-back-link {\n\tposition: relative;\n\tmargin-right: 0.1em;\n\ttop: -0.2em;\n}\n\n.ck .footnotes .footnote-back-link > sup {\n\tmargin-right: 0;\n}\n\n.ck .footnote-item::before {\n\tcontent: counter(footnote-counter) \". \";\n\tdisplay: inline-block;\n\tposition: relative;\n\tright: 0.2em;\n\tmin-width: fit-content;\n\ttext-align: right;\n}\n\n.ck .footnote-content {\n\tdisplay: inline-block;\n\tpadding: 0 0.3em;\n\twidth: 95%;\n\tborder-radius: 2px;\n\tflex-grow: 1;\n}\n\n.ck .ck-widget.footnote-section .ck-widget__type-around__button_after {\n\tdisplay:none; /* hides the 'insert after' button from the ckeditor widget */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
